export const styles = {
    container: {
        marginTop: 3.5,
        marginBottom: 2,
        paddingLeft: 1,
        paddingRight: 4,
        bottom: 0,
        width: "-webkit-fill-available",
        "@supports (-moz-appearance:none)": {
            width: "-moz-available"
        }
    },
    cancelButton: {
        marginRight: 2
    }
};
